import { useCallback, useMemo } from 'react'

import { ampli } from '../../../ampli'

interface FeatureInterestProps {
  feature_name: string
}

const canTrack = (): boolean => typeof window !== 'undefined' && ampli.isLoaded

export const useFeatureInterestTracker = () => {
  const teaserOpened = useCallback((props: FeatureInterestProps) => {
    if (!canTrack()) return
    ampli.track({ event_type: 'Feature teaser opened', event_properties: props })
  }, [])

  const interestClicked = useCallback((props: FeatureInterestProps) => {
    if (!canTrack()) return
    ampli.track({ event_type: 'Feature interest clicked', event_properties: props })
  }, [])

  return useMemo(() => ({ teaserOpened, interestClicked }), [teaserOpened, interestClicked])
}
